import { Component, Input } from '@angular/core'
import { isNil } from 'lodash'
import { EntityChanges } from '../models/entities-with-changes/entity-with-changes.type'

@Component({
  selector: 'scope-field-difference',
  templateUrl: './scope-field-difference.component.html',
})
export class ScopeFieldDifferenceComponent {
  @Input() isChangeRequest: boolean
  @Input() fieldName: string
  @Input() defaultValue: any
  @Input() changes: EntityChanges
  @Input() highlightColors: boolean

  @Input() valueFn: (value: any) => any
  @Input() getFieldToDisplay: (fieldName: string) => number | string
  @Input() showDiff: (fieldName: string) => boolean

  @Input() showNetDelta: boolean
  @Input() netDeltaValue: number

  getFieldValue = () => (isNil(this.defaultValue) ? this.getFieldToDisplay(this.fieldName) : this.defaultValue)
}
